import { Button, colors } from '@ui-components/neo.tax';

import { RD_HELP_URL } from '@neo.tax/shared/constants';
import { useChangeBodyBackgroundColor } from '@neo.tax/shared/hooks';

import { Logo, BlockerContainer, BlockerSubtitle, BlockerTextContainer, BlockerTitle } from './blocker.styled';

export const Blocker = ({ description, title }: { title: string; description: string }): React.ReactElement => {
  useChangeBodyBackgroundColor(colors.gray['800']);

  return (
    <BlockerContainer direction="column" alignItems="center" justifyContent="center" gap={14}>
      <Logo />
      <BlockerTextContainer direction="column" gap={7} alignItems="center">
        <BlockerTitle fontSize="5xl" textAlign="center">
          {title}
        </BlockerTitle>
        <BlockerSubtitle fontSize="2xl" textAlign="center" lineHeight={8}>
          {description}
        </BlockerSubtitle>
      </BlockerTextContainer>
      <Button variant="white" size="xl" rounded="regular" as="a" href={RD_HELP_URL} target="_blank" rel="noreferrer">
        Talk to Us
      </Button>
    </BlockerContainer>
  );
};
